import React from 'react';
import { Box, TableColumnType, Flex, Icon, Modal, Table, Text } from '@fullstory/components';
import { NamedElementDetailsModalProps } from '../types';
import { useObjectSearch } from './useObjectSearch';
import { dateFormat } from '@fullstory/util/date';
import { LibraryObject, getIconForObject, getPathForObject } from './util';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { fullstorySelectors } from '@fullstory/redux';
import { FormattedMessage } from 'react-intl';

type ModalBodyUsagesProps = Pick<NamedElementDetailsModalProps, 'details'>;

const Row = ({ object }: { object: LibraryObject }) => {
  const orgId = useSelector(fullstorySelectors.getOrgId);
  return (
    <Link to={getPathForObject(orgId, object)} data-component="row">
      <Box width={400} display="flex" flexDirection="row" gap={8} alignItems="center">
        <Icon name={getIconForObject(object)} color="secondary" />
        <Text appearance="bodyMedium" noWrap>
          {object.name}
        </Text>
      </Box>
    </Link>
  );
};

const columns: TableColumnType<LibraryObject>[] = [
  {
    key: 'object',
    label: 'Object',
    renderCell(object) {
      return <Row object={object} />;
    },
  },
  {
    key: 'creator',
    label: 'Creator',
    renderCell({ createdBy }) {
      return <Text appearance="bodyMedium">{createdBy}</Text>;
    },
  },
  {
    key: 'last-modified',
    label: 'Last modified',
    renderCell({ lastUpdated }) {
      return (
        <Text appearance="bodyMedium">
          {dateFormat(lastUpdated, {
            format: 'short',
          })}
        </Text>
      );
    },
  },
];

export const ModalBodyUsages: React.FC<ModalBodyUsagesProps> = ({ details }) => {
  const { matches } = useObjectSearch(
    details.namedElement?.namedElement?.id || 'impossiblestringtomatch',
  );

  return (
    <Modal.Body data-component="ModalBodyDetails">
      <Box paddingBottom={16}>
        <Box paddingBottom={16}>
          <Box marginBottom={20}>
            <Text appearance="heading3">{details.namedElement?.namedElement?.name}</Text>
          </Box>
          <Flex column alignItems="stretch" gap={32}>
            {matches.length > 0 ? (
              <Table
                columns={columns}
                rows={matches}
                rowKeyAccessor={row => row.id}
                headProps={{ variant: 'dark', rowProps: { cellProps: { fixed: true } } }}
              />
            ) : (
              <Text appearance="bodyMedium">
                <FormattedMessage
                  defaultMessage="This element is not used in any other objects."
                  id="TprBbd"
                />
              </Text>
            )}
          </Flex>
        </Box>
      </Box>
    </Modal.Body>
  );
};
